import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Mail } from "lucide-react";

const SUBSTACK_URL = "https://buildermantra.substack.com";

export default function NewsletterModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="newsletter-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Mail className="h-5 w-5 text-brand" /> Daily Newsletter
          </DialogTitle>
          <DialogDescription>
            Get fresh fellowships, grants, and founder events in your inbox every day — powered
            by our Substack.
          </DialogDescription>
        </DialogHeader>

        <div className="overflow-hidden rounded-md border border-border">
          <iframe
            data-testid="substack-embed-iframe"
            src={`${SUBSTACK_URL}/embed`}
            width="100%"
            height="320"
            style={{ background: "white", border: "none" }}
            frameBorder="0"
            scrolling="no"
            title="Subscribe to BuilderMantra on Substack"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
